import { tv } from 'tailwind-variants';

interface Props {
  status?: string | null;
  badge?: string | null;
  className?: string;
}

const badgeVariants = tv({
  base: 'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium text-white backdrop-blur-sm',
  variants: {
    status: {
      checked_in: 'bg-green-500/80',
      on_shift: 'bg-emerald-500/80',
      passive: 'bg-blue-500/70',
    },
  },
  defaultVariants: { status: 'passive' },
});

const dotVariants = tv({
  base: 'size-1.5 rounded-full bg-white',
  variants: {
    pulse: { true: 'animate-pulse' },
  },
});

export function AvailabilityBadge({ status, badge, className }: Props) {
  if (!badge || !status || status === 'none') return null;

  const isCheckedIn = status === 'checked_in';
  const isOnShift = status === 'on_shift';
  const isActive = isCheckedIn || isOnShift;

  const resolvedStatus = isCheckedIn
    ? 'checked_in'
    : isOnShift
      ? 'on_shift'
      : 'passive';

  return (
    <span className={badgeVariants({ status: resolvedStatus, class: className })}>
      {isActive && <span className={dotVariants({ pulse: isCheckedIn })} />}
      {badge}
    </span>
  );
}
